module.exports = __webpack_public_path__ + "img/kxc.be9eb498.png";